// Shared by the inventory list's Location QR cell and the Equipment Location modal, so a
// warehouse's slot breakdown reads identically wherever it is hovered.

import pxToRem from "assets/theme/functions/pxToRem";
import { Colors } from "utils/Constants";

// Non-interactive with an instant exit and a dwell delay so sweeping the table never leaves
// two tooltips on screen at once.
export const darkTooltipProps = {
  arrow: true,
  disableInteractive: true,
  enterDelay: 400,
  enterNextDelay: 400,
  leaveDelay: 0,
  TransitionProps: { timeout: 0 },
  componentsProps: {
    tooltip: {
      sx: {
        backgroundColor: Colors.BLACK,
        color: Colors.WHITE,
        fontSize: pxToRem(12),
        fontWeight: 400,
        lineHeight: 1.7,
        whiteSpace: "pre-line",
        textAlign: "left",
        padding: `${pxToRem(8)} ${pxToRem(12)}`,
      },
    },
    arrow: { sx: { color: Colors.BLACK } },
  },
};

/**
 * One `label  (quantity)` line per entry, newline-joined for a `whiteSpace: "pre-line"`
 * tooltip. Entries without a quantity show the label alone rather than a misleading zero.
 *
 * Used for warehouse slots (`QR (qty)`) and for the orders behind a project's dispatched
 * quantity (`order number (qty)`).
 *
 * @param {Array} entries `[{ label, quantity }]`
 * @returns {String}
 */
export const buildQuantityLines = (entries = []) =>
  entries
    .map((entry) =>
      entry?.quantity === null || entry?.quantity === undefined
        ? entry?.label
        : `${entry?.label}  (${entry.quantity})`
    )
    .join("\n");
